import PageLayout from "Layouts/PageLayout";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import PrintIcon from "Assets/SVG/PrintIcon";
import React from "react";
import TransferTypeForm from "../../../Features/Prints/Components/TransferTypeForm";

const New = () => {
    
    const { t } = useTranslation();
    
    const navigate = useNavigate();
    
    return (
        <PageLayout title={t('newTransferType')} icon={<PrintIcon />} includeBox>
            <TransferTypeForm onSubmit={_ => navigate(-1)} />
        </PageLayout>
    )
}

export default New
